import { FaShieldAlt } from "react-icons/fa";
import { PersonalVaultViewMain } from "../Components/PersonalVaultViewMain";
import { PersonalVaultGroupDetailViewMain } from "../Components/PersonalVaultGroupDetailViewMain";

export const PersonalVaultModule = (DATA_USER_AUTH = null) => [
    {
        views: "PRIVATE", path: "/personal-vault/:groupId", component: <PersonalVaultGroupDetailViewMain />,
        roles: null, permissions: null, label: "Detalle de bóveda personal", icon: null,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/personal-vault", component: <PersonalVaultViewMain />,
        roles: null, permissions: null, label: "Bóveda personal", icon: <FaShieldAlt />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: true,
        isBlockedWhenLogged: false,
    },
];
